// @noflow
import { getControlPanelHeight, getTimeAxisHeight, getWeekHeight } from '../utils';
import React, { Component } from 'react';

import ControlPanel from '../control-panel';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { isDependentOn } from '~/core/utils/custom-prop-types';
import Popup from '../popup';
import PropTypes from 'prop-types';
import Slider from '../slider';
import styled from 'styled-components';
import SVGDefinitions from './definitions';
import TimeAxis from '../time-axis';
import { VelocityTransitionGroup } from 'velocity-react';
import Week from '../week';

const MINUTES_IN_DAY = 1440;
const MINIMUM_EVENT_DURATION = 15;

const Container = styled.svg`
    flex: ${p => `1 0 ${p.theme.viewportMinWidth}`};
    max-width: 100%;
`;

export default class SVGContainer extends Component {
    static propTypes = {
        componentId: PropTypes.string.isRequired,
        dragging: ImmutablePropTypes.map,
        height: PropTypes.number.isRequired,
        numEventsInSelectedDay: isDependentOn(
            ['selectedDay'],
            (_, selectedDay) => selectedDay !== null,
            PropTypes.number.isRequired
        ),
        selectedDay: PropTypes.number,
        selectedEvent: ImmutablePropTypes.contains({
            dayIndex: PropTypes.number.isRequired,
            eventIndex: PropTypes.number.isRequired,
            start: PropTypes.number.isRequired
        }),
        showingPopup: PropTypes.bool.isRequired,
        updateEventStart: PropTypes.func.isRequired,
        width: PropTypes.number.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            isDragging: false,
            temporaryStartTime: null
        };
    }

    onStart = xPos => {
        const { selectedEvent } = this.props;
        const startTime = selectedEvent.get('start');
        this.setState({
            initialStartTime: startTime,
            isDragging: true,
            startXPos: xPos,
            temporaryStartTime: startTime
        });
    };

    onMove = xPos => {
        const { height, numEventsInSelectedDay, selectedEvent, width } = this.props;
        const { isDragging, initialStartTime, startXPos } = this.state;
        const timeAxisHeight = getTimeAxisHeight(height);
        if (isDragging) {
            let newStart =
                initialStartTime + Math.floor((xPos - startXPos) * MINUTES_IN_DAY / (width - 2 * timeAxisHeight));
            newStart = Math.round(newStart / MINIMUM_EVENT_DURATION) * MINIMUM_EVENT_DURATION;
            // check that the start time is valid (leaving space to the other events)
            const eventIndex = selectedEvent.get('eventIndex');
            newStart = Math.max(eventIndex * MINIMUM_EVENT_DURATION, newStart);
            newStart = Math.min(
                MINUTES_IN_DAY - (numEventsInSelectedDay - eventIndex - 1) * MINIMUM_EVENT_DURATION,
                newStart
            );
            this.setState({ temporaryStartTime: newStart });
        }
    };

    onEnd = () => {
        const { selectedEvent, updateEventStart } = this.props;
        const { temporaryStartTime } = this.state;
        if (temporaryStartTime !== null) {
            updateEventStart(selectedEvent.get('dayIndex'), selectedEvent.get('eventIndex'), temporaryStartTime);
        }
        this.setState({ isDragging: false, temporaryStartTime: null });
    };

    render() {
        const { componentId, height, selectedDay, selectedEvent, showingPopup, width } = this.props;
        const { isDragging, temporaryStartTime } = this.state;

        // define the heigh of every section
        const controlPanelHeight = getControlPanelHeight(height);
        const timeAxisHeight = getTimeAxisHeight(height);
        const weekHeight = getWeekHeight(height);

        const isSliderShown = !!selectedEvent && selectedEvent.get('dayIndex') === selectedDay;

        return (
            <Container data-qa="schedule-svg" height={height} width={width}>
                <SVGDefinitions componentId={componentId} />
                <ControlPanel
                    componentId={componentId}
                    height={controlPanelHeight}
                    sideMarginWidth={timeAxisHeight}
                    width={width}
                />
                <TimeAxis
                    height={timeAxisHeight}
                    isSliderShown={isSliderShown}
                    top={controlPanelHeight}
                    width={width}
                />
                <Week
                    componentId={componentId}
                    height={weekHeight}
                    isDragging={isDragging}
                    sideMarginWidth={timeAxisHeight}
                    temporaryStartTime={temporaryStartTime}
                    top={controlPanelHeight + timeAxisHeight}
                    width={width}
                />
                {isSliderShown && (
                    <Slider
                        componentId={componentId}
                        height={height}
                        isDragging={isDragging}
                        key={`slider-for-event-${selectedEvent.get('dayIndex')}-${selectedEvent.get('eventIndex')}`}
                        onEnd={this.onEnd}
                        onMove={this.onMove}
                        onStart={this.onStart}
                        temporaryStartTime={temporaryStartTime}
                        top={controlPanelHeight + timeAxisHeight}
                        width={width - 2 * timeAxisHeight}
                    />
                )}
                <VelocityTransitionGroup
                    component="g"
                    enter={{ animation: { opacity: 1 }, duration: 300 }}
                    leave={{ animation: { opacity: 0 }, duration: 300 }}
                >
                    {showingPopup && <Popup componentId={componentId} height={height} width={width} />}
                </VelocityTransitionGroup>
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/svg-container/component.js